import { types, actions } from './requests'
export const MERGEPACKAGING_TYPES = {
    ...types('MERGEPACKAGING'),
}
export const MERGEPACKAGING_ACTIONS = {
    ...actions('MERGEPACKAGING'),
}